import type { CSSProperties } from "react";

export function HeroHeadline() {
  return (
    <div className="flex w-full flex-col items-center pt-9 pb-[22px] text-center">
      <div className="tracking-[-2.1468px]">
        <p
          className="reveal reveal-1 text-4xl font-black leading-[1.1] text-[#3e025c] sm:text-6xl md:text-7xl lg:text-[80px] lg:leading-[79px]"
        >
          Need a loan?
        </p>
        <p
          className="reveal reveal-2 text-4xl font-black leading-[1.1] text-[#176766] sm:text-6xl md:text-7xl lg:text-[85.87px] lg:leading-[79px]"
        >
          Get money moving
        </p>
      </div>

      <div className="reveal-mask mt-4">
        <p
          className="max-w-[1065px] px-4 text-xl font-black tracking-[-1px] text-[#3e025c] sm:text-3xl lg:text-5xl lg:leading-[79px]"
          style={{ "--reveal-delay": "0.25s" } as CSSProperties}
        >
          Add on salary income within minutes
        </p>
      </div>

      <p className="reveal reveal-4 mt-[10px] w-full max-w-[1065px] px-6 text-base leading-[1.5] text-[#57534e] sm:text-lg lg:text-[22.73px] lg:leading-[35.358px]">
        Get the funds you need for unexpected expenses, planned purchases, or
        everyday needs — with a simple digital loan journey based on your
        salary income.
      </p>
    </div>
  );
}
